import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _20mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"20mp"}/>
}
